import React from 'react';

import './FormHeader.scss';
import bem from '../../utils/bem';

const FormHeader = ({
  logoUrl,
  sectionHeader,
  isLoading,
  car,
  headerText,
  headerSubText,
  bottomBorder,
}) => (
  <div className={bem('form-header', {'bottom-border': bottomBorder, 'no-logo':!logoUrl})}>
    <div className="form-header__subinfo">
      {logoUrl && !isLoading && (
        <div className="form-header__brand">
          <img
            src={logoUrl}
            alt=""
          />
        </div>
      )}
        <div className="form-header__bar">
          <h2>{headerText}</h2>
          {headerSubText && <h3>{headerSubText}</h3>}
        </div>
        {/* {isLoading && <div className="form-top-information--brand-loading" />} */}

    </div>    
  </div>
);

export default FormHeader;
